import {REDUCER_NAME as PARENT_REDUCER_NAME} from '../const'
import {REDUCER_NAME} from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_PROCESS_COMMENT = NS + 'CHANGE_PROCESS_COMMENT'
export const CHANGE_IS_COMMENT_INTERNAL = NS + 'CHANGE_IS_COMMENT_INTERNAL'

export const COMMENT_PROCESS_INSTANCE_REQUEST = NS + 'COMMENT_PROCESS_INSTANCE_REQUEST'
export const COMMENT_PROCESS_INSTANCE_SUCCESS = NS + 'COMMENT_PROCESS_INSTANCE_SUCCESS'
export const COMMENT_PROCESS_INSTANCE_ERROR = NS + 'COMMENT_PROCESS_INSTANCE_ERROR'

export const FIND_PROCESS_COMMENT_REQUEST = NS + 'FIND_PROCESS_COMMENT_REQUEST'
export const FIND_PROCESS_COMMENT_SUCCESS = NS + 'FIND_PROCESS_COMMENT_SUCCESS'
export const FIND_PROCESS_COMMENT_ERROR = NS + 'FIND_PROCESS_COMMENT_ERROR'



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/tab-comments/type.js